// extracted by mini-css-extract-plugin
export default {"centered":"styles_centered__j0I7d"};